import { CaseMedicalDocument } from '../../../domain/case/model/case-medical-document.dto';
import { CaseMedicalDocumentType } from '../../../domain/case/model/case-medical-document-type';

export type PreparationFileStatus = 'uploading' | 'uploaded' | 'error';

export interface CasePreparationFileEntry {
  clientId: string;
  file?: File;
  fileName: string;
  originalFileName: string;
  size: number | null;
  extension: string | null;
  url: string | null;
  status: PreparationFileStatus;
  progress: number | null;
  canDelete: boolean;
  documentId: number | null;
  include: boolean;
  type: CaseMedicalDocumentType | null;
  documentDate: string | null;
}

export class CasePreparationFilesActions {
  static readonly SeedFromCaseDetail = class {
    static readonly type = '[CasePreparationFiles] SeedFromCaseDetail';
    constructor(
      public readonly caseId: number,
      public readonly documents: CaseMedicalDocument[]
    ) {}
  };

  static readonly AddLocalFile = class {
    static readonly type = '[CasePreparationFiles] AddLocalFile';
    constructor(
      public readonly caseId: number,
      public readonly entry: CasePreparationFileEntry
    ) {}
  };

  static readonly UpdateProgress = class {
    static readonly type = '[CasePreparationFiles] UpdateProgress';
    constructor(
      public readonly caseId: number,
      public readonly clientId: string,
      public readonly progress: number
    ) {}
  };

  static readonly MarkUploaded = class {
    static readonly type = '[CasePreparationFiles] MarkUploaded';
    constructor(
      public readonly caseId: number,
      public readonly clientId: string,
      public readonly document: CaseMedicalDocument
    ) {}
  };

  static readonly MarkError = class {
    static readonly type = '[CasePreparationFiles] MarkError';
    constructor(
      public readonly caseId: number,
      public readonly clientId: string
    ) {}
  };

  static readonly SetUploading = class {
    static readonly type = '[CasePreparationFiles] SetUploading';
    constructor(
      public readonly caseId: number,
      public readonly clientId: string
    ) {}
  };

  static readonly Remove = class {
    static readonly type = '[CasePreparationFiles] Remove';
    constructor(
      public readonly caseId: number,
      public readonly clientId: string
    ) {}
  };

  static readonly UpdateMetadata = class {
    static readonly type = '[CasePreparationFiles] UpdateMetadata';
    constructor(
      public readonly caseId: number,
      public readonly clientId: string,
      public readonly patch: Partial<
        Pick<
          CasePreparationFileEntry,
          'fileName' | 'include' | 'type' | 'documentDate'
        >
      >
    ) {}
  };

  static readonly ClearCase = class {
    static readonly type = '[CasePreparationFiles] ClearCase';
    constructor(public readonly caseId: number) {}
  };
}
